import React from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import Home from "./components/layout/Home";
import About from "./components/layout/About";
import Skills from "./components/layout/Skills";
import Experience from "./components/layout/Experience";
import Articles from "./components/layout/Articles";
import Footer from "./components/layout/Footer";
import "./styles/App.css";
import Project from "./components/layout/Project";
import Experiments from "./components/layout/Experiments";
import SplatPage from "./components/layout/SplatPage";

const MainLayout = () => (
  <div className="App">
    <Home />
    <About />
    <Project />
    <Experiments />
    <Skills />
    <Experience />
    <Articles />
    <Footer />
  </div>
);

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<MainLayout />} />
        <Route path="/splat/my-table" element={<SplatPage src="https://superspl.at/s?id=e2288845" title="My Table - 3D Gaussian Splatting" />} />
        <Route path="/splat/laksa" element={<SplatPage src="https://superspl.at/s?id=ade3ee90" title="Laksa - 3D Gaussian Splatting" />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
